module.exports = __webpack_public_path__ + "first-500_signature.jpg?462cae20510372b1d817aeb335c17f6d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-500_signature.jpg
// module id = 561
// module chunks = 0